module.exports = __webpack_public_path__ + "static/img/14.5558fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14.jpg
// module id = zcya
// module chunks = 1